<template lang="pug">
.container-restricao
        div(
            v-if='restricoes.length > 0',
            :class='restricoes[index].inibido ? "camada-inibida" : ""',
            v-for='(restricao, index) in listaRestricoes'
        )
            slot(name='botaoInibir', :restricao='restricoes[index]')
            .card-restricao
                .container-restricao-acoes(
                    v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
                )
                    div
                        BaseButton(
                            size='small',
                            icon='mdi mdi-crosshairs-gps',
                            @click='aplicarZoomRestricao(index)'
                        )
                slot(name='selecionarRestricao', :restricao='restricoes[index]')
                p
                    b Categoria:
                    |
                    | {{ restricao.categoria || '-' }}
                    br
                    b Governo:
                    |
                    | {{ restricao.governo || '-' }}
                    br
                    b Órgão:
                    |
                    | {{ restricao.orgao || '-' }}
                    br
                    b Nome:
                    |
                    | {{ restricao.nome }}
                    br
                    b Ato legal:
                    |
                    | {{ restricao.atolegal || '-' }}
                    br
                    b Classe:
                    |
                    | {{ restricao.classe }}
                    br
                    b Código:
                    |
                    | {{ restricao.codigo || '-' }}
                    br
                    b Ano:
                    |
                    | {{ restricao.ano || '-' }}
                    br
                    b UF:
                    |
                    | {{ restricao.uf }}
                    br
                    b Tipo proteção:
                    |
                    | {{ restricao.protecao }}
                    br
                    b Tipo floresta:
                    |
                    | {{ restricao.tipo }}
                    span &nbsp;
                    el-tooltip(effect='light', placement='right').tooltip-floresta
                        span(slot='content')
                            div.tooltip-content
                                h3 Existem três tipos de florestas públicas federais:
                                p
                                    strong.titulo TIPO A (FPA)
                                    br
                                    strong Descrição:&nbsp;
                                    span São florestas que apresentam destinação e dominialidade específica como as Unidades de Conservação&nbsp;
                                    span da Natureza, as Terras Indígenas, os Assentamentos Rurais Públicos, as áreas militares e outras formas de destinação previstas em lei.&nbsp;
                                    span São destinadas à proteção e conservação do meio ambiente e uso de comunidades tradicionais
                                hr
                                p
                                    strong.titulo TIPO B (FPB)
                                    br
                                    strong Descrição:&nbsp;
                                    span São as florestas localizadas em áreas arrecadadas pelo Poder Público, mas que ainda não foram destinadas.
                                hr
                                p
                                    strong.titulo TIPO C (FPC)
                                    br
                                    strong Descrição:&nbsp;
                                    span São as florestas localizadas em áreas de dominialidade indefinida, comumente chamadas de terras devolutas.
                                
                                p.fonte Fonte: Ministério da Agricultura e Pecuária
                        span
                            i.information-card.mdi.mdi-information-outline.criterio-fora-regiao.icone
                    
                    br
                    b Bioma:
                    |
                    | {{ restricao.bioma || '-' }}
                    br
                    b Estágio:
                    |
                    | {{ restricao.estagio || 'Não informado' }}
                    br
                    b Área (ha):
                    |
                    | {{ formatNumber(restricao.areaHa) }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                    |
                    | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                    Criticidade(
                        v-if='restricao.nivelAlerta'
                        :restricao='restricao'
                    )
                    
</template>
    
<script>
    import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
    import formatters from '@/utils/formatters';
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';
    
    export default {
        name: 'florestas-publicas',
    
        data() {
            return {};
        },

        components: {
            Criticidade,
            BaseButton
        },
    
        computed: {
            listaRestricoes: function () {
                return this.restricoes.map(value => {
                    if (value.properties) {
                        return {
                            ...value.properties
                        };
                    }
                    return value;
                });
            }
        },
    
        methods: {
            aplicarZoomRestricao(index) {
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes
                );
            },
            formatNumber(number) {
                if (!number) return '-';
                return formatters.maxFormatNumber(number, 2);
            },
            formatNumberPercent(number) {
                if (!number) return '-';
                return formatters.maxFormatNumber(number, 2) + '%';
            }
        },
    
        props: {
            restricoes: {
                type: Array,
                required: true
            },
            geometria: {
                type: Array,
                required: false,
                default: null
            },
            habilitarZoomRestricao: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    };
</script>
<style>

.tooltip-content{
    width: 500px;
}
.tooltip-content p {
    margin-top: 10px;
}

.tooltip-content h3, .tooltip-content p .titulo {
    color: var(--primary);
    font-weight: 600;
}
.tooltip-floresta{
    font-size: 16px;
}
.fonte{
    text-align: right;
}
</style>
